import { Box, type BoxProps, styled } from "@mui/material"
import { DotIcon, type IconUrlsProps } from "../IconUrls"

export interface AlertIconContainerProps extends BoxProps {
  slotProps?: {
    dotIcon?: IconUrlsProps
  }
}

export const AlertIconContainer = ({
  children,
  slotProps,
  ...containerProps
}: AlertIconContainerProps) => (
  <Container {...containerProps}>
    {children}
    <DotIcon
      color="common.orange"
      size="10px"
      {...slotProps?.dotIcon}
      style={{
        position: "absolute",
        top: -2,
        right: 0,
        ...slotProps?.dotIcon?.style,
      }}
    />
  </Container>
)

const Container = styled(Box)({
  position: "relative",
  display: "grid",
  placeContent: "center",
  borderRadius: "1000px",
  width: "34px",
  aspectRatio: "1/1",
  border: "1px solid",
})
